/**
 * WhatWeDo — Short intro section on the home page.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useReveal } from '../../hooks/useReveal';
import styles from './WhatWeDo.module.css';

function WhatWeDo() {
  const { ref, visible } = useReveal();

  return (
    <section
      ref={ref}
      className={`${styles.section} roar-reveal ${visible ? 'is-visible' : ''}`}
    >
      <div className={styles.inner}>
        <h2 className={styles.title}>What we do</h2>
        <div>
          <p className={styles.body}>
            Roarbotics is Fairfax High School&apos;s FTC team. Each fall we start
            from a blank CAD model; by spring we&apos;re on the competition floor
            with a robot we designed, machined, wired, and programmed ourselves.
            Along the way we run outreach, mentor younger students, and learn how
            real engineering teams work.
          </p>
          <Link to="/about" className={styles.link}>
            Read our story →
          </Link>
        </div>
      </div>
    </section>
  );
}

export default WhatWeDo;
